import { NewTypography as Typography, useViewport } from '@lamimed/pantheon';
import { StaticImageData } from 'next/image';

import * as S from '../../styles';

export interface CardProps {
  image: StaticImageData;
  title?: string;
  description: string;
}

export const Card = ({ image, title, description }: CardProps) => {
  const { greaterThan } = useViewport();

  return (
    <S.CardWrapper>
      <S.CardImage
        src={image}
        alt={`${title} photo`}
        width={greaterThan('tablet') ? 55 : 40}
        height={greaterThan('tablet') ? 55 : 40}
        placeholder="blur"
        quality={100}
      />

      <S.CardDescription>
        <Typography marginBottom="none" fontWeight="bold">
          {title}
        </Typography>

        <Typography marginBottom="none" variant="body_text_3">
          {description}
        </Typography>
      </S.CardDescription>
    </S.CardWrapper>
  );
};
